import { LAYOUTS, POSITION, } from "@voltmoney/types";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StepperTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { horizontalStepperRepo } from "../../../configs/utils";
import { authenticateRepayment, goBack, GoToDashboard, NavLoanAgreement, NavLoanRepayment, openLinkInNewTab, PollMandateStatus, } from "./actions";
import { Platform, } from 'react-native';
import { fetchLinkRepo } from "./repo";
export const template = (stepper, url) => ({
    layout: {
        id: ROUTE.LOAN_REPAYMENT,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "headSpace1", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP },
            { id: "headSpace2", type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP },
            {
                id: "headerStack",
                type: WIDGET.HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            { id: "headerSpace", type: WIDGET.SPACE },
            { id: "headItem", type: WIDGET.TEXT },
            { id: "headSpace", type: WIDGET.SPACE },
            { id: "contentItem", type: WIDGET.TEXT },
            { id: "contentSpace", type: WIDGET.SPACE },
            { id: "iconStack", type: WIDGET.STACK },
            { id: "iconSpace", type: WIDGET.SPACE },
            { id: "btnData", type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM },
        ],
    },
    datastore: {
        headerStack: {
            // leadIcon: `${url}`,
            title: "Setup AutoPay",
            type: HeaderTypeTokens.verification,
            stepperProps: {
                type: StepperTypeTokens.HORIZONTAL,
                data: stepper,
            },
            action: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.LOAN_REPAYMENT,
                payload: {},
            },
        },
        headSpace1: { size: Platform.OS === 'ios' ? SizeTypeTokens.LG : SizeTypeTokens.NONE },
        headSpace2: { size: Platform.OS === 'ios' ? SizeTypeTokens.LG : SizeTypeTokens.NONE },
        headerSpace: { size: SizeTypeTokens.LG },
        headItem: {
            label: "Link bank account for AutoPay",
            fontSize: FontSizeTokens.MD,
            lineHeight: 24,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: "700",
        },
        headSpace: { size: SizeTypeTokens.MD },
        contentItem: {
            label: "Hassle-free repayment of interest charges at the start of every month.",
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
        },
        contentSpace: { size: SizeTypeTokens.XXXXL },
        iconStack: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "upsideSpace", type: WIDGET.SPACE },
                { id: "upsideSpace1", type: WIDGET.SPACE },
                { id: "icon", type: WIDGET.ICON },
                { id: "downsideSpace", type: WIDGET.SPACE },
                { id: "downsideSpace1", type: WIDGET.SPACE },
            ],
        },
        upsideSpace: { size: SizeTypeTokens.XXXXL },
        upsideSpace1: { size: SizeTypeTokens.MD },
        downsideSpace: { size: SizeTypeTokens.XXXXL },
        downsideSpace1: { size: SizeTypeTokens.MD },
        icon: {
            name: IconTokens.AutoPayArrow,
            size: IconSizeTokens.XXXXXXXXL,
        },
        iconSpace: { size: SizeTypeTokens.XXXXXXL },
        btnData: {
            type: StackType.column,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "btnItem", type: WIDGET.BUTTON },
                { id: "btnSpace", type: WIDGET.SPACE },
                { id: "disclaimerStack", type: WIDGET.STACK },
            ],
        },
        btnItem: {
            label: "Continue",
            type: ButtonTypeTokens.LargeFilled,
            labelColor: ColorTokens.White,
            id: "continue_bt_repayment",
            width: ButtonWidthTypeToken.FULL,
            action: {
                type: ACTION.REPAYMENT,
                payload: { value: url },
                routeId: ROUTE.LOAN_REPAYMENT,
            },
        },
        btnSpace: { size: SizeTypeTokens.LG },
        disclaimerStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: "secureIcon", type: WIDGET.ICON },
                { id: "secureSpace", type: WIDGET.SPACE },
                { id: "secureText", type: WIDGET.TEXT },
            ],
        },
        secureIcon: {
            name: IconTokens.SafeGuard,
            size: IconSizeTokens.XS,
        },
        secureSpace: {
            size: SizeTypeTokens.LG,
        },
        secureText: {
            label: "AutoPay is safe & secure",
            color: ColorTokens.Secondary_100,
            fontSize: FontSizeTokens.XXS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "500",
        },
    },
});
export const loanRepaymentMF = {
    onLoad: async ({ network }) => {
        const stepper = await horizontalStepperRepo(network);
        const responseX = await fetchLinkRepo();
        const url = responseX.stepResponseObject;
        return Promise.resolve(template(stepper, url));
    },
    actions: {
        [ACTION.REPAYMENT]: authenticateRepayment,
        [ACTION.GO_BACK]: goBack,
        // [ACTION.LINK_POLL]: AutoPayPoll,
        [ACTION.OPEN_TAB]: openLinkInNewTab,
        [ACTION.POLL_MANDATE_STATUS]: PollMandateStatus,
        [ACTION.GO_LOAN_AGREEMENT]: NavLoanAgreement,
        [ACTION.GO_LOAN_REPAYMENT]: NavLoanRepayment,
        [ACTION.GO_T0_DASHBOARD]: GoToDashboard,
    },
};
